var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-center"},[(!!_vm.currentUser && _vm.shouldShowSecurityCheck)?_c('Auth'):(_vm.isForgotPasswordActive)?_c('ForgotPassword'):_c('Preauth'),_c('LanguageSelector')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }